import React from "react";
import { Switch, Route } from "react-router-dom";
import { candidate } from "routes/paths";
import SignUp from "./SignUp";
import DashboardMain from "./DashboardMain";
import DashboardCall from "./DashboardCall";
import EditProfile from "./EditProfile";
import Referral from "./Referral";
import ReferralSuccess from "./ReferralSuccess";
import Call from "./Call";
import CancelCall from "./CancelCall";
import CancelCallSuccess from "./CancelCallSuccess";
import ScheduleCall from "./ScheduleCall";
import Insider from "./Insider";
import InsidersList from "./InsidersList";
import Payment from "./Payment";
import PaymentSuccess from "./PaymentSuccess";
import Reschedule from "./Reschedule";
import RescheduleSuccess from "./RescheduleSuccess";
import ProfileSetup from "./ProfileSetup";
import Feedback from "./Feedback";
import FeedbackSuccess from "./FeedbackSuccess";
import ChooseTime from "./ChooseTime";
import Consultation from "./Consultation";
import Main from "./Main";

export default () => (
  <Switch>
    <Route exact path={candidate.signUp} component={SignUp} />
    <Route exact path={candidate.onboarding} component={ProfileSetup} />
    <Route
      exact
      path={candidate.candidateDashboard}
      component={DashboardMain}
    />
    <Route
      exact
      path={candidate.candidateDashboardCall}
      component={DashboardCall}
    />
    <Route exact path={candidate.editProfile} component={EditProfile} />
    <Route exact path={candidate.inviteFriend} component={Referral} />
    <Route exact path={candidate.inviteSuccess} component={ReferralSuccess} />
    <Route exact path={candidate.call} component={Call} />
    <Route exact path={candidate.cancelCall} component={CancelCall} />
    <Route exact path={candidate.cancelSuccess} component={CancelCallSuccess} />
    <Route exact path={candidate.scheduleCall} component={ScheduleCall} />
    <Route exact path={candidate.insiderProfile} component={Insider} />
    <Route exact path={candidate.main} component={InsidersList} />
    <Route exact path={candidate.profiles} component={Main} />
    <Route exact path={candidate.pay} component={Payment} />
    <Route exact path={candidate.paymentSuccess} component={PaymentSuccess} />
    <Route exact path={candidate.reschedule} component={Reschedule} />
    <Route
      exact
      path={candidate.rescheduleSuccess}
      component={RescheduleSuccess}
    />
    <Route exact path={candidate.onInsiderFeedback} component={Feedback} />
    <Route
      exact
      path={candidate.candidateFeedbackSuccess}
      component={FeedbackSuccess}
    />
    <Route exact path={candidate.chooseTime} component={ChooseTime} />
    <Route exact path={candidate.consultation} component={Consultation} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/index.js